<template>
  <div class="x-tablelist-view" data-automation="access">
    <!-- 搜索行 -->
    <ux-searchOption
      :layout="layout"
      :data="filter"
      @search="seach"
      @input="seach"
      @add="showAdd"
      @resetsearch="resetsearch"
    ></ux-searchOption>
    <!-- 表格 -->
    <div class="x-table-box">
      <ux-table
        ref="table"
        maxHeight="100%"
        :hide-on-single-page="true"
        :data="tableData.list"
        :columns="columns"
        :total="tableData.totalSize"
        :size.sync="filter.size"
        :page.sync="filter.page"
        @changePage="changePage"
        @changeSize="changeSize"
        :emptyText="$t('HT.nodata')"
        layout="total, sizes, prev, pager, next"
      ></ux-table>

      <!-- <my-table ref="table" xborder maxHeight="100%" :tableData="tableData.list" :columns="columns" :total="tableData.totalSize" :current.sync="filter.page" @changePage="changePage" @changeSize="changeSize"></my-table> -->
    </div>
  </div>
</template>
<script>
import addFlow from './template/addFlow';
import bindFlowApp from './template/bindFlowApp';
import unbindFlowApp from './template/unbindFlowApp';
export default {
  components: {
    addFlow,
    bindFlowApp,
    unbindFlowApp
  },
  data() {
    return {
      layout: [
        // 搜索项配置
        {
          type: 'input',
          key: 'name',
          width: '420px',
          placeholder: this.$t('HT.flowList.name.placeholder')
        },
        {
          type: 'button',
          text: this.$t('HT.reset'),
          plain: true,
          event: 'resetsearch'
        },
        {
          type: 'button',
          text: this.$t('HT.add'),
          icon: 'ux_icon_plus',
          right: true,
          hidden: !this.$hasModule(14),
          event: 'add'
        }
      ],
      columns: [
        // 表头数据
        {
          label: this.$t('HT.addFlow.name'),
          prop: 'name',
          tooltip: true,
          align: 'left',
          render: (h, params) => {
            return h(
              'span',
              {
                class: ['x-table-blue-btn'],
                on: {
                  click: () => {
                    this.$router.push(`/flowInfo/${params.id}`);
                  }
                }
              },
              params.name
            );
          }
        },
        {
          label: this.$t('HT.bindFlowApp.rate'),
          prop: 'rate',
          align: 'left',
          tooltip: true
        },
        {
          label: this.$t('HT.flowList.unit'),
          prop: 'unit',
          tooltip: true,
          align: 'left',
          formatter: (row, column, cellValue) => {
            return this.$opt.switchStr(cellValue, this.$opt.unit);
          }
        },
        {
          label: this.$t('HT.operation'),
          hidden: !this.$hasModule(14),
          align: 'left',
          render: (h, params) => {
            return h('my-table-btn', {
              props: {
                data: [this.$t('HT.edit'), this.$t('HT.delete')],
                colors: ['#0087ff'],
                event: ['edit', 'del']
              },
              on: {
                edit: () => {
                  this.$router.push(`/flowInfo/${params.id}`);
                  // this.showEdit(params);
                },
                del: () => {
                  const title = this.$t('HT.flowList.del');
                  const content = this.$t('HT.flowList.del.placeholder');
                  this.$uxModal.show({
                    title,
                    content,
                    confirm: () => {
                      this.delList(params.id);
                    }
                  });
                }
              }
            });
          }
        }
      ],
      filter: {
        // 查询参数
        name: '', // 流量控制名称
        page: 1,
        size: 10
      },
      tableData: {
        // 表格数据
        totalSize: 0,
        list: []
      }
      // list: [], // 应用列表
    };
  },
  created() {
    this.getList(this.filter);
  },
  methods: {
    /**
     * 获取列表
     * @param {Object} params 请求参数
     */
    getList(params) {
      this.$uxLoading.show();
      this.$api.flow.getList(params).then((res) => {
        if (res.code == 10000) {
          this.tableData = {
            totalSize: res.total_size,
            list: res.data
          };
        }
      });
    },
    /**
     * 重置搜索项
    */
    resetsearch() {
      console.log('重置');
      this.filter.name = '';
      this.seach();
    },
    /**
     * 添加列表
     * @param {Object} params 表单提交参数
     */
    addList(params) {
      this.$uxLoading.show();
      this.$api.flow.addList(params).then((res) => {
        if (res.code == 10000) {
          this.$uxModal.hide();
          this.$uxMessage.success(this.$t('HT.addApi.addSuccess'));
          this.getList(this.filter);
        }
      });
    },

    /**
     * 修改列表
     * @param {Object} params 表单提交参数
     */
    putList(params) {
      this.$uxLoading.show();
      this.$api.flow.putList(params).then((res) => {
        if (res.code == 10000) {
          this.$uxModal.hide();
          this.$uxMessage.success(this.$t('HT.addApi.editSuccess'));
          this.getList(this.filter);
        }
      });
    },

    /**
     * 删除列表
     * @param {String} id 唯一标识
     */
    delList(id) {
      this.$uxLoading.show();
      this.$api.flow.delList(id).then((res) => {
        if (res.code == 10000) {
          this.$uxModal.hide();
          this.$uxMessage.success(this.$t('HT.addApi.delSuccess'));
          if (this.tableData.list.length === 1) {
            this.filter.page = this.filter.page - 1 ? this.filter.page - 1 : 1;
          }
          this.getList(this.filter);
        }
      });
    },

    /**
     * 新增-弹窗
     */
    showAdd() {
      const title = this.$t('HT.flowList.add');
      this.$uxModal.show({
        title,
        content: (h) => {
          return h(addFlow, {
            on: {}
          });
        },
        confirm: (data) => {
          this.addList(data);
        }
      });
    },

    /**
     * 编辑
     * @param {Object} params 单行表格数据
     */
    showEdit(params) {
      const title = this.$t('HT.flowList.edit');
      this.$uxModal.show({
        title,
        content: (h) => {
          return h(addFlow, {
            props: { data: params },
            on: {}
          });
        },
        confirm: (data) => {
          this.putList(data);
        }
      });
    },

    /**
     * 搜索
     */
    seach() {
      this.filter.page = 1;
      this.getList(this.filter);
    },

    /**
     * 改变页容量
     * @param {Number} size 选择的页容量
     */
    changeSize(size) {
      this.filter.size = size;
      this.filter.page = 1;
      this.getList(this.filter);
    },
    /**
     * 改变页码
     * @param {Number} page 选择的页码
     */
    changePage(page) {
      this.filter.page = page;
      this.getList(this.filter);
    }
  }
};
</script>
